import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

const initialState = {
	list: [],
	rate: null,
	error: "",
	loading: false,
};

// ADD_rate
export const addRate = createAsyncThunk(
	"rate/addRate",
	async (values) => {
		try {
			const { data } = await axios({
				method: "post",
				url: `rate`,
				data: {
					...values,
				},
			});
			toast.success("Rate added successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in adding Rate try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

// DELETE_rate
export const deleteRate = createAsyncThunk(
	"rate/deleteRate ",
	async (id) => {
		try {
			const resp = await axios({
				method: "delete",
				headers: {
					Accept: "application/json",
					"Content-Type": "application/json;charset=UTF-8",
				},
				url: `rate/${id}`,
			});

			toast.success("Rate deleted successfully!");
			return {
				data: resp.data.id,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in deleting rate try again");
			console.log(error.message);
		}
	}
);

// rate_DETAILS
export const loadSinglePublicHoliday = createAsyncThunk(
	"rate/loadSinglePublicHoliday",
	async (id) => {
		try {
			const data = await axios.get(`rate/${id}`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

// rate
export const getAllRate = createAsyncThunk(
	"rate/getAllRate",
	async () => {
		try {
			const { data } = await axios.get(`rate`);
			return data;
		} catch (error) {
			console.log(error.message);
		}
	}
);

export const updateRate = createAsyncThunk(
	"rate/updateRate",
	async ({ id, values }) => {
		try {
			const { data } = await axios({
				method: "put",

				url: `rate/${id}`,
				data: {
					...values,
				},
			});
			toast.success("Rate updated successfully!");
			return {
				data,
				message: "success",
			};
		} catch (error) {
			toast.error("Error in updating Rate try again");
			console.log(error.message);
			return {
				message: "error",
			};
		}
	}
);

const rateSlice = createSlice({
	name: "rate",
	initialState,
	reducers: {
		clearRate: (state) => {
			state.rate = null;
		},
	},
	extraReducers: (builder) => {
		// 1) ====== builders for getAllRate ======

		builder.addCase(getAllRate.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(getAllRate.fulfilled, (state, action) => {
			state.loading = false;
			state.list = action.payload;
		});

		builder.addCase(getAllRate.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 2) ====== builders for addRate  ======

		builder.addCase(addRate.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(addRate.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(addRate.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});




		// 3) ====== builders for rate ======

		builder.addCase(updateRate.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(updateRate.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(updateRate.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});

		// 4) ====== builders for deleteRate  ======

		builder.addCase(deleteRate.pending, (state) => {
			state.loading = true;
		});

		builder.addCase(deleteRate.fulfilled, (state, action) => {
			state.loading = false;
		});

		builder.addCase(deleteRate.rejected, (state, action) => {
			state.loading = false;
			state.error = action.payload.message;
		});
	},
});

export default rateSlice.reducer;
export const { clearRate } = rateSlice.actions;
